import { ComponentType } from "react";

import { getOverrideFrom, OverrideTokens, TokenProps } from "src/brand/overrides";
import { useBrand } from "src/core/contexts/BrandContext";

export function withOverride<T extends keyof OverrideTokens>(
  token: T,
  Fallback: ComponentType<TokenProps<T>>
): ComponentType<TokenProps<T>> {
  type P = TokenProps<T>;
  const Wrapped = (props: P) => {
    const { brand } = useBrand();
    const Impl = getOverrideFrom(brand, token) as ComponentType<P> | undefined;
    const Comp: ComponentType<P> = Impl ?? Fallback;

    return <Comp {...props} />;
  };
  Wrapped.displayName = `Override(${String(token)})`;

  return Wrapped;
}

/** Strict : override OBLIGATOIRE → throw si manquant */
export function withRequiredOverride<T extends keyof OverrideTokens>(
  token: T
): ComponentType<TokenProps<T>> {
  type P = TokenProps<T>;
  const Wrapped = (props: P) => {
    const { brand } = useBrand();
    const Impl = getOverrideFrom(brand, token) as ComponentType<P> | undefined;

    if (!Impl) {
      throw new Error(
        `[Brand override missing] token="${String(token)}" brand="${brand}".\n` +
          `Ajoute dans src/brand/overrides.ts : { "${String(token)}": VotreComposant }`
      );
    }
    const Comp: ComponentType<P> = Impl;

    return <Comp {...props} />;
  };
  Wrapped.displayName = `RequiredOverride(${String(token)})`;

  return Wrapped;
}
